import { jsx as so } from "react/jsx-runtime";
import { useState as C, useMemo as g, useCallback as d } from "react";
import { a as F, i as E, b as ao } from "../../core-DVmjA3_O.js";
import { _ as ro } from "../../cs-Dfox81s-.js";
import { u as co } from "../../list-PuqEMMrN.js";
import "../../type-Dku6Xzl6.js";
import { l as I } from "../../transform-DVGbLiBW.js";
import lo from "../SelectInputContainer/index.js";
import { m as po, G as x } from "../../common-BopMAF3A.js";
import ho from "./Option/index.js";
import '../../index56.css';const uo = "_option-container_2k92q_1", fo = "_option_2k92q_1", Co = "_active_2k92q_9", mo = "_icon_2k92q_12", m = {
  optionContainer: uo,
  option: fo,
  active: Co,
  icon: mo
}, L = [];
function Vo(h) {
  const {
    keySelector: t,
    labelSelector: i,
    descriptionSelector: v,
    name: u,
    onChange: b,
    onOptionsChange: O,
    options: W,
    optionsPending: R,
    optionsErrored: j,
    value: e,
    prevValue: S,
    withDiffView: V,
    sortFunction: f,
    searchOptions: A,
    onSearchValueChange: a,
    onShowDropdownChange: l,
    hideOptionFilter: _,
    selectedOnTop: K,
    onEnterWithoutOption: w,
    ...B
  } = h, p = W ?? L, N = A ?? L, [s, y] = C(), [G, P] = C(!1), [H, z] = C(!1), [
    J,
    k
  ] = C(), [D, q] = C({}), M = g(
    () => I(p, t, i),
    [p, t, i]
  ), Q = g(
    () => po(e, S, V),
    [S, e, V]
  ), U = F(e) ? M[e] ?? "?" : "", X = F(S) ? M[S] : null, T = g(
    () => {
      const o = p == null ? void 0 : p.find((n) => t(n) === e);
      return E(o) ? [] : [o];
    },
    [e, p, t]
  ), Y = g(
    () => {
      const o = co(
        [...N, ...T],
        t
      );
      if (!K)
        return f ? f(o, s, i) : o;
      const n = o.filter((c) => D[t(c)]), r = o.filter((c) => !D[t(c)] && (E(_) || _(c)));
      return f ? [
        ...x(n, s, i),
        ...f(r, s, i)
      ] : [
        ...x(n, s, i),
        ...r
      ];
    },
    [
      K,
      t,
      i,
      s,
      N,
      D,
      T,
      f,
      _
    ]
  ), Z = d(
    (o) => {
      y(o), a && a(o);
    },
    [a]
  ), $ = d(() => {
    P(!1), l && l(!1), y(void 0), a && a(void 0), w && w(s);
  }, [s, l, w, a]), oo = d(
    (o) => {
      P(o), l && l(o), o ? (q(
        I(
          e ? [e] : [],
          (n) => n,
          () => !0
        )
      ), k(e ? { key: e } : void 0)) : (q({}), k(void 0), y(void 0), a && a(void 0));
    },
    [e, a, l]
  ), eo = d(
    (o, n) => {
      const r = o === e;
      return {
        label: i(n),
        description: v ? v(n) : void 0,
        containerClassName: ro(m.optionContainer, r && m.active),
        title: i(n),
        className: m.option,
        iconClassName: m.icon
      };
    },
    [e, i, v]
  ), no = d(
    (o, n) => {
      O && O(((r) => {
        const c = r ?? [];
        return c.find((io) => t(io) === o) ? r : [...c, n];
      })), b(o, u, n);
    },
    [b, u, O, t]
  ), to = d(
    () => {
      if (!h.nonClearable) {
        const o = h.onChange;
        o(void 0, u, void 0);
      }
    },
    // eslint-disable-next-line react/destructuring-assignment
    [u, h.onChange, h.nonClearable]
  );
  return /* @__PURE__ */ so(
    lo,
    {
      ...B,
      name: u,
      options: Y,
      optionsPending: R,
      optionsErrored: j,
      optionsFiltered: ao(s) && s.length > 0,
      optionKeySelector: t,
      optionRenderer: ho,
      optionRendererParams: eo,
      optionContainerClassName: m.optionContainer,
      onOptionClick: no,
      valueDisplay: U,
      onClearButtonClick: to,
      searchText: s,
      onSearchTextChange: Z,
      dropdownShown: G,
      onDropdownShownChange: oo,
      focused: H,
      onFocusedChange: z,
      focusedKey: J,
      onFocusedKeyChange: k,
      hasValue: F(e),
      persistentOptionPopup: !1,
      onEnterWithoutOption: $,
      prevValue: X,
      highlightMode: Q
    }
  );
}
export {
  Vo as default
};
